module.exports = __webpack_public_path__ + "static/google-08f822dea084e53ab5d1d1b2378a9784.png";